import { useState } from 'react'
import { PageHeader } from '@/widgets/layout/ui/AppLayout'
import { Button } from '@/shared/ui'
import { useAdminCalls } from '@/entities/admin'
import { AdminCallsTable } from '../shared/AdminCallsTable'
import { AdminPagination, AdminRemoteState } from '../shared/AdminRemoteState'
import { formatNumber } from '../shared/format'
import styles from '../AdminPages.module.css'

const LIMIT = 50

export function AdminCallsPage() {
  const [companyId, setCompanyId] = useState('')
  const [kind, setKind] = useState('')
  const [status, setStatus] = useState('')
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [offset, setOffset] = useState(0)

  const parsedCompanyId = companyId ? Number(companyId) : undefined
  const calls = useAdminCalls({
    companyId:
      parsedCompanyId && Number.isInteger(parsedCompanyId) && parsedCompanyId > 0
        ? parsedCompanyId
        : undefined,
    kind: kind || undefined,
    status: status || undefined,
    from: from || undefined,
    to: to || undefined,
    limit: LIMIT,
    offset,
  })

  function reset() {
    setCompanyId('')
    setKind('')
    setStatus('')
    setFrom('')
    setTo('')
    setOffset(0)
  }

  return (
    <>
      <PageHeader
        title="Звонки"
        description="Все телефонные и тестовые звонки по компаниям."
      />

      <div className={styles.toolbar}>
        <label className={styles.field}>
          <span className={styles.label}>ID компании</span>
          <input
            className={styles.input}
            type="number"
            min="1"
            inputMode="numeric"
            value={companyId}
            onChange={(event) => {
              setCompanyId(event.target.value)
              setOffset(0)
            }}
            placeholder="Все компании"
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Тип звонка</span>
          <select
            className={styles.select}
            value={kind}
            onChange={(event) => {
              setKind(event.target.value)
              setOffset(0)
            }}
          >
            <option value="">Все типы</option>
            <option value="phone">Телефонный</option>
            <option value="test">Тестовый</option>
          </select>
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Состояние</span>
          <select
            className={styles.select}
            value={status}
            onChange={(event) => {
              setStatus(event.target.value)
              setOffset(0)
            }}
          >
            <option value="">Все состояния</option>
            <option value="pending">Ожидает</option>
            <option value="active">Идёт</option>
            <option value="completed">Завершён</option>
            <option value="failed">Ошибка</option>
          </select>
        </label>
        <label className={styles.field}>
          <span className={styles.label}>С даты</span>
          <input
            className={styles.input}
            type="date"
            value={from}
            onChange={(event) => {
              setFrom(event.target.value)
              setOffset(0)
            }}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>По дату</span>
          <input
            className={styles.input}
            type="date"
            value={to}
            min={from || undefined}
            onChange={(event) => {
              setTo(event.target.value)
              setOffset(0)
            }}
          />
        </label>
        <Button variant="ghost" onClick={reset}>
          Сбросить
        </Button>
        <span className={styles.count}>Найдено: {formatNumber(calls.data?.total ?? 0)}</span>
      </div>

      {calls.isPending ? (
        <AdminRemoteState kind="loading" />
      ) : calls.isError ? (
        <AdminRemoteState
          kind="error"
          message="Список звонков не загрузился."
          onRetry={() => void calls.refetch()}
        />
      ) : !calls.data?.items.length ? (
        <AdminRemoteState
          kind="empty"
          title="Звонков не найдено"
          message="Измените фильтры или выберите другой период."
        />
      ) : (
        <>
          <AdminCallsTable
            items={calls.data.items}
            elevenLabsUsdPer1kCredits={calls.data.elevenLabsUsdPer1kCredits}
          />
          <AdminPagination
            total={calls.data.total}
            offset={offset}
            limit={LIMIT}
            onChange={setOffset}
            disabled={calls.isFetching}
          />
        </>
      )}
    </>
  )
}
